// extracted by css-extract-rspack-plugin
export default {"monospace":"oUD80"};